import React from "react";

/**
 * Shared neo-brutalist dark cyber page header.
 * Pattern: cyan uppercase eyebrow, orbitron title, muted subtitle,
 * subtle cyan 120° gradient + 38px grid lines, sharp 1px slate underline.
 * Right slot renders page-specific actions.
 */
export const PageHeader = ({ eyebrow, title, subtitle, actions, icon: Icon, testId }) => (
  <header
    className="relative overflow-hidden border-b border-slate-800 pb-7 pt-2 md:pt-5"
    data-testid={testId || "page-header"}
  >
    <div
      className="pointer-events-none absolute inset-0 opacity-25"
      style={{
        backgroundImage:
          "linear-gradient(120deg, rgba(6,182,212,.16), transparent 48%), linear-gradient(rgba(6,182,212,.08) 1px, transparent 1px), linear-gradient(90deg, rgba(6,182,212,.08) 1px, transparent 1px)",
        backgroundSize: "auto, 38px 38px, 38px 38px",
      }}
    />
    <div className="relative flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
      <div className="min-w-0 max-w-3xl">
        {eyebrow ? (
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-cyan-400">
            {Icon ? <Icon className="h-3.5 w-3.5" /> : null}
            {eyebrow}
          </p>
        ) : null}
        <h1
          className="mt-2 font-orbitron text-3xl font-bold text-white sm:text-4xl md:text-5xl"
          data-testid={testId ? `${testId}-title` : undefined}
        >
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-400 sm:text-base">
            {subtitle}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2 md:justify-end" data-testid={testId ? `${testId}-actions` : undefined}>
          {actions}
        </div>
      ) : null}
    </div>
  </header>
);

export default PageHeader;
